// import axios from 'axios';
import React, { useState } from 'react'
import { LOCAL_STORAGE_KEYS, ROUTES } from '../helpers/constants';
import { Outlet, useNavigate } from 'react-router';
import { AuthContext } from './authContext';
// import { Navigate, useNavigate } from 'react-router-dom';
// import { local_storage_KELOCAL_STORAGE_KEYS } from '../config/type';
// import { API_BASE_URL_v1 } from '../config/axios';

export default function AuthProvider(props) {
    const [user, setUser] = useState({ isLoggedIn: false, data: {}, isLoading: true });
    const navigate = useNavigate();

    const logOut = () => {
        localStorage.removeItem(LOCAL_STORAGE_KEYS.TOKEN)
        navigate(ROUTES.MAIN, { replace: true })
    }

    let value = { logOut, user, setUser }
    return (
        <AuthContext.Provider value={value} >
            <Outlet />
        </AuthContext.Provider>
    )
}